import React, {useState} from 'react';

import './styles.scss';
import * as fonts from '../../../util/fonts';
import {FormControlProps} from 'react-bootstrap';
import {Column, Row} from '../../layout';
import {createClassName} from '../../../util/utility';
import {connect} from 'react-redux';
import RadioChecked from '../../../assets/icons/RadioChecked';
import RadioUnchecked from '../../../assets/icons/RadioUnchecked';

export interface Option {
  value: any;
  label: string;
}

interface AppRadioSelectInputProps extends FormControlProps {
  onChange(value: any): any;
  value?: any;
  options: Option[];
  rowDirection?: boolean;
  onBlur?(): void;
  globalStyles: any;
}

function AppRadioSelectInput({
  value,
  onChange,
  options,
  rowDirection,
  onBlur,
  className,
  globalStyles,
}: AppRadioSelectInputProps) {
  const classes = createClassName('app-radio-button-row', className);

  const [selectedValue, setSelectedValue] = useState(value);

  const onChangeValue = (value: string) => {
    setSelectedValue(value);
  };

  const renderContent = () => {
    return options.map((option) => (
      <Row className={classes}>
        <div
          onClick={() => {
            onChangeValue(option.value);
            onChange(option.value);
          }}>
          {option.value === selectedValue ? (
            <RadioChecked />
          ) : (
            <RadioUnchecked />
          )}
        </div>
        <div
          style={{...fonts.M}}
          className={
            rowDirection
              ? 'row-app-radio-button-label'
              : 'app-radio-button-label'
          }>
          {option.label}
        </div>
      </Row>
    ));
  };

  return (
    <>
      {rowDirection ? (
        <Row>{renderContent()}</Row>
      ) : (
        <Column>{renderContent()}</Column>
      )}
    </>
  );
}

const mapStateToProps = ({globalStyles}: any) => ({
  globalStyles: globalStyles.value,
});

export default connect(mapStateToProps)(AppRadioSelectInput);
